module.exports = __webpack_public_path__ + "img/4 - 4 - 2.a99de204.jpg";